import { FaMapMarkerAlt, FaTags, FaCalendarAlt, FaUsers, FaHourglass, FaUserCog, FaBirthdayCake, FaMobileAlt, FaBreadSlice, FaCookieBite, FaUtensils, FaGifts, FaDollarSign } from 'react-icons/fa';

// Function to render the appropriate icon based on the name
export const renderIcon = (iconName) => {

  // Convert the name to lowercase
  const lowercaseName = iconName.toLowerCase();

  // Check the lowercase name and return the corresponding icon component
  switch (lowercaseName) {

    /*----- Services -----*/
    case 'custom cake design':
      return <FaBirthdayCake />; // Birthday cake icon

    case 'online ordering':
      return <FaMobileAlt />; // Mobile phone icon

    case 'specialty breads':
      return <FaBreadSlice />; // Bread slice icon

    case 'baking workshops':
      return <FaCookieBite />; // Cookie bite icon

    case 'catering & events':
      return <FaUtensils />; // Utensils (fork & spoon) icon

    case 'gift hampers':
      return <FaGifts />; // Gift box icon

    /*----- Page Sidebar -----*/
    case 'date':
      return <FaCalendarAlt />; // Calendar icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
      return <FaMapMarkerAlt />; // Location icon

    case 'value':
      return <FaDollarSign />; // Dollar Sign icon

    case 'headbaker':
      return <FaUserCog />; // User icon

    default: 
      return null; // Return null if no matching icon is found
  }

};